/** UPI collect for school fee dues (Axis Bank / okbizaxis). */
const UPI_VPA = '9451093677@okbizaxis';
const UPI_PAYEE_NAME = 'MODERN PUBLIC SCHOOL';

/**
 * Build UPI deep link for student fee payment.
 * @param {{ amountDue: number|string, studentName?: string }} opts
 * @returns {string|null}
 */
export function buildSchoolUpiLink({ amountDue, studentName }) {
  const amount = Number(amountDue);
  if (!Number.isFinite(amount) || amount <= 0) return null;
  const name = String(studentName || 'Student').trim();
  const params = new URLSearchParams();
  params.set('pa', UPI_VPA);
  params.set('pn', UPI_PAYEE_NAME);
  params.set('am', String(amount));
  params.set('cu', 'INR');
  params.set('tn', `(${name} Dues)`);
  return `upi://pay?${params.toString()}`;
}
